(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lase-config-summary"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cfg-summary-section]').forEach((section) => {
      const track = section.querySelector('[data-cfg-summary]');
      const prev  = section.querySelector('[data-build-prev]');
      const next  = section.querySelector('[data-build-next]');
      const nav   = section.querySelector('.mono-variants__nav');
      if (!track) return;

      const getStep = () => {
        const item = track.querySelector('.mono-variants__item');
        if (!item) return 0;
        const styles = getComputedStyle(track);
        const gap = parseInt(styles.columnGap || styles.gap || '0', 10) || 0;
        return item.getBoundingClientRect().width + gap;
      };
      const updateState = () => {
        const max = track.scrollWidth - track.clientWidth - 1;
        const scrollable = track.scrollWidth > track.clientWidth + 1;
        if (prev) prev.disabled = track.scrollLeft <= 0;
        if (next) next.disabled = track.scrollLeft >= max;
        // Hide the arrows when everything fits (nothing to scroll).
        if (nav) nav.style.visibility = scrollable ? '' : 'hidden';
      };

      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -getStep(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left:  getStep(), behavior: 'smooth' }));
      track.addEventListener('scroll', updateState, { passive: true });
      window.addEventListener('resize', updateState);
      // Cards are injected (and re-injected on every reconfigure) by
      // configurator.js, so re-evaluate arrow state on child changes.
      new MutationObserver(updateState).observe(track, { childList: true });
      updateState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mono-variants"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-mono-variants]');
    sections.forEach((section) => {
      const track = section.querySelector('[data-mono-track]');
      const prev = section.querySelector('[data-mono-prev]');
      const next = section.querySelector('[data-mono-next]');
      if (!track || !prev || !next) return;

      const getStep = () => {
        const firstItem = track.querySelector('.mono-variants__item');
        if (!firstItem) return 0;
        const styles = getComputedStyle(track);
        const gap = parseInt(styles.columnGap || styles.gap || '0', 10) || 0;
        return firstItem.getBoundingClientRect().width + gap;
      };

      const updateState = () => {
        const max = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= max;
      };

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateState, { passive: true });
      window.addEventListener('resize', updateState);
      updateState();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
